import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = [
    'associationInput',
    'singleStateMessage',
    'stateInput',
  ]

  connect() {
    this.handleAssociationChange()
  }

  handleAssociationChange() {
    if (this.associationInputTarget.value === 'naa') {
      leave(this.singleStateMessageTarget)
      enter(this.stateInputTarget)
    } else {
      enter(this.singleStateMessageTarget)
      leave(this.stateInputTarget)
    }
  }
}
